"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray")),
    _react = _interopRequireWildcard(require("react")),
    _reactChartjs = require("react-chartjs-2"),
    _moment = _interopRequireDefault(require("moment")),
    _vars = require("@devsta/ui-kit/dist/common/styles/vars");

require("./_submissions-graph.scss");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

var monkey = _vars.COLOURS.cyan.jungleGreen.monkey,
    bigFat = _vars.COLOURS.grey.athens.bigFat,
    SHADOW_DATA_SET_OPTIONS = {
  label: "video shadow",
  fill: !1,
  lineTension: .5,
  backgroundColor: bigFat,
  borderColor: bigFat,
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  pointRadius: 0,
  pointBackgroundColor: "transparent",
  pointBorderColor: "transparent"
};

function renderGraph(a) {
  if (!a.length) return null;
  var b = [].concat((0, _toConsumableArray2["default"])(a.map(function (b, c) {
    var d = b.date;
    return c === a.length - 1 ? "This Month" : (0, _moment["default"])(d).format("MMM 'YY");
  })), [(0, _moment["default"])().add(1, "M").format("MMM 'YY")]),
      c = a.map(function (a) {
    var b = a.submissions;
    return b;
  }),
      d = c.map(function (a) {
    return 2 > a - 2 ? 0 : a - 2;
  }),
      e = b.map(function (a, c) {
    return c === b.length - 2 ? monkey : _vars.COLOURS.cyan.aqua;
  }),
      f = b.map(function (a, c) {
    return c === b.length - 2 ? 4 : 3;
  }),
      g = {
    labels: b,
    datasets: [_objectSpread(_objectSpread({}, SHADOW_DATA_SET_OPTIONS), {}, {
      label: "videos",
      backgroundColor: monkey,
      borderColor: monkey,
      pointBackgroundColor: e,
      pointBorderColor: e,
      pointRadius: f,
      pointHitRadius: 10,
      data: c
    }), _objectSpread(_objectSpread({}, SHADOW_DATA_SET_OPTIONS), {}, {
      data: d
    })]
  };
  return _react["default"].createElement(_reactChartjs.Line, {
    data: g,
    options: {
      legend: {
        display: !1
      },
      tooltips: {
        displayColors: !1,
        footerAlign: "center",
        xPadding: 15,
        yPadding: 15,
        callbacks: {
          title: function title() {
            return null;
          },
          label: function label(a) {
            return 1 === a.datasetIndex ? null : "".concat(a.value, " videos");
          }
        }
      },
      layout: {
        padding: {
          top: 25,
          bottom: 10,
          left: 60,
          right: 60
        }
      },
      scales: {
        pointLabels: {
          fontStyle: "bold"
        },
        xAxes: [{
          position: "top",
          gridLines: {
            drawBorder: !1,
            display: !0
          },
          ticks: {
            padding: 25
          }
        }],
        yAxes: [{
          display: !1
        }]
      }
    },
    height: 240,
    width: 1400
  });
}

function SubmissionsGraph(a) {
  var b = a.monthlySubmissions;
  return _react["default"].createElement("div", {
    className: "submissions-graph"
  }, _react["default"].createElement("div", {
    className: "submissions-graph__wrapper"
  }, _react["default"].createElement("div", {
    className: "submissions-graph__wrapper__container"
  }, renderGraph(b))));
}

var _default = (0, _react.memo)(SubmissionsGraph);

exports["default"] = _default;